<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="filteredMaintenanceVendors"
            :search="search.input"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Maintenance Vendors</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-select
                                v-model="search.filterBy"
                                :items="search.items"
                                label="Filter By"
                                prepend-inner-icon="mdi-filter"
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-text-field
                                v-model="search.input"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="toggleDialog">
                        <v-icon>mdi-plus</v-icon>
                        Add Maintenance Vendor
                    </v-btn>
                </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
                <tr @contextmenu.prevent="openContextMenu($event, item)">
                    <td>
                        <div>{{ item.id }}</div>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.name" large @save="saveItem(item)">
                            <div>{{ item.name }}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.name" label="Name" single-line></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.phone" large @save="saveItem(item)">
                            <div>{{ item.phone }}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.phone" label="Phone" single-line></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.email" large @save="saveItem(item)">
                            <div>{{ item.email }}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.email" label="Email" single-line></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.address" large @save="saveItem(item)">
                            <div>{{ item.address }}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.address" label="Address" single-line></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.city" large @save="saveItem(item)">
                            <div>{{ item.city }}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.city" label="City" single-line></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.comments" large @save="saveItem(item)">
                            <div>{{ item.comments }}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.comments" label="Comments" single-line></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.status" large @save="saveItem(item)">
                            <div>{{ item.status }}</div>
                            <template v-slot:input>
                                <v-select v-model="item.status" :items="['ACTIVE', 'INACTIVE']" label="Status"></v-select>
                            </template>
                        </v-edit-dialog>
                    </td>
                </tr>
            </template>
        </v-data-table>
        
        <v-dialog v-model="dialog" max-width="500px">
            <v-form v-model="formStatus">
                <v-card>
                    <v-card-title>
                        <span class="headline">Add Maintenance Vendor</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form.name"
                                        label="Name"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form.phone"
                                        label="Phone"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form.email"
                                        label="Email"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form.address"
                                        label="Address"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form.comments"
                                        label="Comments"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        v-model="form.status"
                                        :items="['ACTIVE', 'INACTIVE']"
                                        label="Status"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="toggleDialog">
                            Cancel
                        </v-btn>
                        <v-btn
                            v-if="!form.id"
                            color="blue darken-1"
                            text
                            @click="submit"
                        >
                            Save
                        </v-btn>
                        <v-btn
                            v-if="form.id"
                            color="blue darken-1"
                            text
                            @click="update(true)"
                        >
                            Update
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'MaintenanceVendors',
    props: {
        maintenanceVendors: Array,
        headers: Array
    },
    data: () => ({
        dialog: false,
        search: {
            input: '',
            filterBy: 'all',
            items: [
                {
                    text: 'Active',
                    value: 'active'
                },
                {
                    text: 'Inactive',
                    value: 'inactive'
                },
                {
                    text: 'All',
                    value: 'all'
                },
            ],
        },
        formStatus: false,
        form: {
            name: '',
            phone: '',
            email: '',
            address: '',
            comments: '',
            status: 'ACTIVE'
        }
    }),
    computed: {
        filteredMaintenanceVendors() {
            let filterBy = this.search.filterBy;
            console.log('Filter by: ', filterBy);
            
            if (filterBy == 'active') {
                return this.maintenanceVendors.filter(item => item.status == 'ACTIVE');
            } else if (filterBy == 'inactive') {
                return this.maintenanceVendors.filter(item => item.status == 'INACTIVE');
            } else if (filterBy == 'all') {
                return this.maintenanceVendors;
            } else {
                return [];
            }
        }
    },
    methods: {
        saveItem(item) {
            console.log('From save item');
            console.log(item);
            this.form = { ...item };
            this.update(false);
        },
        toggleDialog(isToggle = true) {
            if (isToggle) {
                this.dialog = !this.dialog;
            }
            this.form = {
                name: '',
                phone: '',
                email: '',
                address: '',
                comments: '',
                status: 'ACTIVE'
            };
        },
        submit() {
            // Save the form
            console.log('Form is valid');
            axios
                .post('v2/maintenance/vendors', this.form)
                .then(response => {
                    console.log(response.data);
                    //Dispatch a success snackbar
                    this.$store.dispatch('setSnackbar', {
                        text: 'New vendor submitted',
                        color: 'success'
                    });
                    this.toggleDialog();
                    //Emmit an event to update the table
                    this.$emit('update');
                })
                .catch(error => {
                    console.log(error);
                    //Dispatch an error snackbar
                    this.$store.dispatch('setSnackbar', {
                        text: 'Error submitting vendor',
                        color: 'error'
                    });
                });
        },
        update(isToggle) {
            // Update the form
            console.log('Form is valid');
            axios
                .put('v2/maintenance/vendors/' + this.form.id, this.form)
                .then(response => {
                    console.log(response.data);
                    //Dispatch a success snackbar
                    this.$store.dispatch('setSnackbar', {
                        text: 'Vendor updated',
                        color: 'success'
                    });
                    this.toggleDialog(isToggle);
                    //Emmit an event to update the table
                    this.$emit('update');
                })
                .catch(error => {
                    console.log(error);
                    //Dispatch an error snackbar
                    this.$store.dispatch('setSnackbar', {
                        text: 'Error updating vendor',
                        color: 'error'
                    });
                });
        },
        openContextMenu(event, item) {
            item = { ...item, catalogKey: 'maintenanceVendors' };
            this.$emit('open-context-menu', { event, item });
        },
    }

    /**
     * Headers:
     * Name, Phone, Email, Address, Comments, Status (ACTIVE, INACTIVE)
     */
};
</script>
